import * as React from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box,Backdrop, Button, Card,CardMedia, CircularProgress, Grid, Stack, Typography } from '@mui/material';

const API = require("../../data/network/API");

export default function Challenges() {

  const [rows, setRows] = React.useState([]);
  const [open, setOpen] = React.useState(false);

  const getChallenges = async () => {
    setOpen(true)
    const response = await API.getChallenges()
    setOpen(false)
    if(response.status == 200){
      console.log(response.body)
      setRows(response.body.data)
    }else{

    }
  }

  React.useEffect(()=>{ 
    getChallenges()
  },[])

  return (
    <Box sx={{ flexGrow: 1, overflow: 'hidden', px: 3, mt:8 }}>    
      <div sx={{ my: 1, mx: 'auto', p: 1 }}>
        <Grid container spacing={0} wrap="nowrap">
          <Grid item xs>
            <Stack spacing={2} sx={{width:"100%"}}>
              <Typography variant="h6" sx={{fontWeight:"bold"}}>¿Como ganas?</Typography>
              <Typography variant="body1">Completa cada uno de los retos para ganar puntos y poder por un premio.</Typography>
            </Stack>
          </Grid>
        </Grid>
        
        <Grid container  alignItems="center" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3}} sx={{ mt:2 }}>
          <Grid item xs={12}  container justify = "center" >
            <Button sx={{textAlign:"left"}} variant="contained" fullWidth color="secondary" endIcon={<ArrowForwardIosIcon /> }>
              Canjea aqui tus puntos por premios y dinero.
            </Button>
          </Grid>
        </Grid>

        <Stack spacing={2} sx={{mt:8}}> 
          {rows?.map((row) => (
            <Card sx={{ borderRadius:2}}>
              <CardMedia
                sx={{ height: 140 }}
                image={row.imagen_url}
                title={row.nombre}
              />
            </Card>
          ))}
        </Stack>
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </Box>
  )
}